export const modalEN = {
    "greska": "Greška", //Za sad dok je sve na hrv
    "zatvori": "Zatvori" //Za sad dok je sve na hrv
};